import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "./common/Sidebar";
import StickyMenu from "./common/StickyMenu";
import MobileMenu from "./common/MobileMenu";
import { Styles } from "./styles/header.js";

import axios from "axios";
import { Constant } from "../helper/Constants.js";

class Header extends Component {
  cancelToken = null;

  state = {
    navbarTexts: [],
  };

  componentDidMount() {
    this.cancelToken = axios.CancelToken.source();
    this.fetchNavbarTexts();
  }

  componentWillUnmount() {
    if (this.cancelToken) this.cancelToken.cancel("Header unmount");
  }

  // safe url checker
  isSafeUrl = (url = "") => {
    try {
      const u = new URL(url, window.location.origin);
      return ["http:", "https:"].includes(u.protocol);
    } catch {
      return false;
    }
  };

  fetchNavbarTexts = async () => {
    const url = Constant.getUrls?.getAllNavbarTexts || "/api/navbartexts";
    try {
      const resp = await axios.get(`${url}?page=1&limit=50`, {
        cancelToken: this.cancelToken.token,
      });
      const rows = resp.data?.data || [];
      const navs = Array.isArray(rows)
        ? rows.filter(
            (r) =>
              (r.is_delete || "no") !== "yes" &&
              (r.status || "active") === "active"
          )
        : [];
      this.setState({ navbarTexts: navs });
    } catch (err) {
      if (!axios.isCancel(err))
        console.error("Error fetching navbar texts:", err);
      this.setState({ navbarTexts: [] });
    }
  };

  openLink = (link) => {
    if (link && this.isSafeUrl(link)) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  render() {
    const { navbarTexts } = this.state;

    const css = `
      /* CTA (unchanged) */
      @keyframes pulseZoomSmall {
        0% { transform: scale(1); }
        50% { transform: scale(1.06); }
        100% { transform: scale(1); }
      }
      .topbar-cta {
        display: flex;
        align-items: center;
        justify-content: space-around;
        gap: 8px;
        min-width: 120px;
        padding: 6px 10px;
        border-radius: 999px;
        background: linear-gradient(90deg,#d9251c,#ff6f6f);
        color: #fff !important;
        font-weight: 700;
        text-decoration: none;
        box-shadow: 0 6px 14px rgba(18,30,78,0.12);
        transform-origin: center;
        animation: pulseZoomSmall 2.6s ease-in-out infinite;
        transition: transform .14s ease, box-shadow .14s ease;
        font-size: 13px;
        line-height: 1;
      }
      .topbar-cta .cta-icon {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: rgba(255,255,255,0.12);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }
      .topbar-cta:hover {
        transform: translateY(-2px) scale(1.02);
        box-shadow: 0 12px 26px rgba(18,30,78,0.16);
      }
      .topbar-left-cta, .topbar-right-cta { display: inline-flex; align-items: center; gap: 8px; }
      @media (max-width: 767px) {
        .topbar-cta { min-width: 44px; padding: 6px; font-weight:700; }
        .topbar-cta span.label { display: none; }
        .topbar-cta .cta-icon { width: 28px; height: 28px; font-size: 13px; }
      }
      .bar-left .list-inline-item, .bar-right .list-inline-item { vertical-align: middle; }

      /* marquee */
      .top-marquee { overflow:hidden; white-space:nowrap; }
      .marquee-inner { display:inline-block; }
      .marquee-item { display:inline-block; margin-right:36px; cursor:pointer; color:inherit; }

      /* HEADER layout & typography */
      .header-main, .logo-area, .top-bar { font-family: "Inter", "Helvetica Neue", Arial, sans-serif; } /* modern stack */

      /* align nav and logo */
      .logo-and-nav { display:flex; align-items:center; gap: 20px; width:100%; }
      .site-logo img { height:52px; width:auto; display:block; }

      /* NAV enhanced visuals + layout fixes */
      .navbar-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 26px;
        font-weight: 600;
        flex-wrap: nowrap; /* prevent wrapping on desktop */
      }

      .nav-link {
        position: relative;
        color: #2b2b2b;
        text-decoration: none;
        padding: 10px 8px;
        font-size: 15px;
        letter-spacing: 0.2px;
        transition: color 180ms ease, transform 160ms ease;
        white-space: nowrap; /* prevent split words */
      }

      /* subtle hover: color + underline slide */
      .nav-link::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -6px;
        width: 0%;
        height: 2px;
        background: #ff6f6f;
        border-radius: 2px;
        transform: translateX(-50%);
        transition: width 220ms ease;
      }
      .nav-link:hover {
        color: #ff6f6f;
        transform: translateY(-1px);
      }
      .nav-link:hover::after {
        width: 56%;
      }

      /* Active page hint (if you add active class later) */
      .nav-link.active {
        color: #ff6f6f;
      }
      .nav-link.active::after {
        width: 56%;
      }

      /* Courses dropdown polished */
      .dropdown-wrap { position: relative; display:inline-block; }
      .dropdown-toggle {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
      }
      .dropdown-menu-custom {
        display: none;
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        min-width: 190px;
        background: #ffffff;
        border-radius: 8px;
        padding: 8px;
        box-shadow: 0 18px 40px rgba(20,24,50,0.08);
        border: 1px solid rgba(20,24,50,0.04);
        z-index: 1000;
      }
      .dropdown-menu-custom .dd-item {
        display: block;
        padding: 10px 12px;
        color: #2b2b2b;
        text-decoration: none;
        border-radius: 6px;
        transition: background 140ms ease, color 140ms ease, transform 120ms ease;
        font-size: 14px;
        white-space: nowrap;
      }
      .dropdown-menu-custom .dd-item:hover {
        background: rgba(247,147,26,0.06);
        color: #ff6f6f;
        transform: translateX(4px);
      }
      .dropdown-wrap:hover .dropdown-menu-custom { display: block; }

      /* responsive fixes: allow wrapping below certain width so items don't cramp */
      @media (max-width: 1100px) {
        .navbar-right { gap: 18px; }
      }
      @media (max-width: 880px) {
        .navbar-right { flex-wrap: wrap; justify-content: center; gap: 14px; }
        .nav-link { font-size: 14px; padding: 8px 6px; }
        .dropdown-menu-custom { display:none !important; } /* mobile menu handles dropdowns */
      }
    `;

    return (
      <Styles>
        <style>{css}</style>

        {/* Topbar (unchanged CTA UI & marquee) */}
        <section className="top-bar">
          <Container>
            <Row className="align-items-center">
              {/* LEFT: Franchise CTA + Location */}
              <Col lg="4" md="5">
                <div
                  className="bar-left d-flex align-items-center"
                  style={{ justifyContent: "space-around" }}
                >
                  <div className="topbar-left-cta" style={{ marginRight: 12 }}>
                    <a
                      href="/franchise-enquiry"
                      className="topbar-cta"
                      title="Franchise Tie-Up"
                      style={{ cursor: "pointer", }}
                    >
                      <span className="label" style={{ textAlign: "center" }}>
                        Franchise Enquiry
                      </span>
                    </a>
                  </div>

                  <ul className="list-unstyled list-inline mb-0">
                    <li className="list-inline-item">
                      <i className="las la-map-marker"></i> Nagpur, Maharashtra
                    </li>
                  </ul>
                </div>
              </Col>

              {/* CENTER: Running marquee text — dynamic */}
              <Col lg="6" md="12" className="d-none d-md-block">
                <div className="top-marquee">
                  <div className="marquee-inner">
                    {navbarTexts && navbarTexts.length > 0 ? (
                      navbarTexts.map((n) => {
                        const txt = n.title || "";
                        const link = n.link || "";
                        const hasLink =
                          link &&
                          link.trim().length > 0 &&
                          this.isSafeUrl(link);
                        return (
                          <span
                            key={n._id || txt}
                            className="marquee-item"
                            onClick={() =>
                              hasLink ? this.openLink(link) : null
                            }
                            role={hasLink ? "link" : "text"}
                            title={hasLink ? "Open link in new tab" : undefined}
                            style={{
                              textDecoration: hasLink
                                ? "underline dotted"
                                : "none",
                            }}
                          >
                            {txt}
                          </span>
                        );
                      })
                    ) : (
                      <>
                        <span className="marquee-item">Take our Franchise</span>
                        <span className="marquee-item">
                          Contact us for School Tieup
                        </span>
                        <span className="marquee-item">Best Coaching</span>
                      </>
                    )}
                  </div>
                </div>
              </Col>

              {/* RIGHT: School Tie-Up CTA (unchanged) */}
              <Col lg="2" md="7">
                <div className="bar-right d-flex justify-content-end align-items-center">
                  <div className="topbar-right-cta">
                    <a
                      href="/abacus-school"
                      className="topbar-cta"
                      title="School Tie-Up"
                    >
                      <span className="label">School Tie-Up</span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* LOGO + NAV */}
        <section className="logo-area">
          <Container>
            <Row className="align-items-center">
              <Col md="3">
                <div className="site-logo">
                  <Link to={process.env.PUBLIC_URL + "/"}>
                    <img
                      src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                      alt="Logo"
                      style={{ height: 52 }}
                    />
                  </Link>
                </div>
              </Col>

              <Col md="9">
                <div
                  className="logo-and-nav"
                  style={{ justifyContent: "flex-end" }}
                >
                  <nav className="navbar-right" aria-label="Main navigation">
                    <Link to="/about" className="nav-link">
                      About Us
                    </Link>

                    <div className="dropdown-wrap">
                      <span className="nav-link dropdown-toggle">
                        Abacus Classes{" "}
                        <span style={{ fontSize: 12, opacity: 0.7 }}>▾</span>
                      </span>
                      <div
                        className="dropdown-menu-custom"
                        role="menu"
                        aria-hidden="true"
                      >
                        <Link
                          to="/abacus-online"
                          className="dd-item"
                          role="menuitem"
                        >
                          Abacus Online Classes
                        </Link>
                        <Link
                          to="/abacus-near"
                          className="dd-item"
                          role="menuitem"
                        >
                          Abacus Near Me
                        </Link>
                        <Link
                          to="/abacus-school"
                          className="dd-item"
                          role="menuitem"
                        >
                          Abacus School
                        </Link>
                      </div>
                    </div>

                    <Link to="/course-grid" className="nav-link">
                      Courses
                    </Link>

                    <Link to="/events" className="nav-link">
                      Events
                    </Link>
                    <Link to="/exams-list" className="nav-link">
                      Competitive Exams
                    </Link>
                    <Link to="/blogs" className="nav-link">
                      Blogs
                    </Link>
                    <Link to="/gallery" className="nav-link">
                      Gallery
                    </Link>
                    <Link to="/contact" className="nav-link">
                      Contact Us
                    </Link>

                    {/* <Sidebar /> */}
                  </nav>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Sticky & Mobile */}
        <StickyMenu />
        {
          window.innerWidth<760 && (

            <MobileMenu />
          )
        }
      </Styles>
    );
  }
}

export default Header;
